// angular
import { ChangeDetectorRef, Component, effect, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
// components
import { NoContentComponent } from '@app/core/components/no-content/no-content.component';
import { ProductCardSkeletonComponent } from '@app/core/components/product-card/product-card-skeleton/product-card-skeleton.component';
import { ProductCardComponent } from '@app/core/components/product-card/product-card.component';
// services
import { FavoritesService } from '../shared/favorites.service';
// interfaces
import { IProduct } from '@app/+products/shared/interfaces/product.interface';

@Component({
  selector: 'pwj-favorite-items',
  standalone: true,
  imports: [
    NoContentComponent,
    ProductCardComponent,
    TranslateModule,
    ProductCardSkeletonComponent,
  ],
  templateUrl: './favorite-items.component.html',
  styleUrl: './favorite-items.component.scss',
})
export class FavoriteItemsComponent {
  public currentTab!: string;
  public noContentMessage: string = `profile.favorites.noFavoriteProduct`;
  public favoritesData!: IProduct[];
  public isLoading!: boolean;

  // dependencies
  private readonly _favoritesService = inject(FavoritesService);
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _cd = inject(ChangeDetectorRef);

  constructor() {
    // fetch favorite products
    this._favoritesService.getFavoriteProducts({});

    // set current tab
    this.currentTab = 'products';

    // empty favorites data on tab change
    this._activatedRoute.url.subscribe(url => {
      this.favoritesData = [];
      this.currentTab = url[0]?.path;
    });

    // get products favorites
    effect(() => {
      // get favorites products
      this.favoritesData = this._favoritesService.favoriteProductsList();
    });

    // get loading state
    effect(() => {
      this.isLoading = this._favoritesService.isFavoriteProductsLoading();
      this._cd.detectChanges();
    });
  }

  // for future
  public onTabChange() {
    // switch (this.currentTab) {
    //   case 'products':
    //     {
    //       // set no content message base on current tab
    //       this.noContentMessage = `profile.favorites.noFavoriteProduct`;
    //     }
    //     break;
    //   case 'blogs':
    //     {
    //       // set no content message base on current tab
    //       this.noContentMessage = `profile.favorites.noFavoriteBlog`;
    //     }
    //     break;
    //   case 'posts':
    //     {
    //       // set no content message base on current tab
    //       this.noContentMessage = `profile.favorites.noFavoritePost`;
    //     }
    //     break;
    // }
  }
}
